import BaseLoader from 'components/atoms/base-loader';

import styles from './styles.module.scss';

import type { FC } from 'react';

interface Props {
  isLoading: boolean;
}

const TranscriptLoader: FC<Props> = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <div className={styles['transcript-loader']}>
      <BaseLoader loading={isLoading} />
    </div>
  );
};

export default TranscriptLoader;
